import axios from 'axios';
import { ADMIN_API_BASE, adminAuthConfig } from './api_admin';

const _err = (e) => { if (e.response) console.error('Admin settings error:', e.response.status, e.response.data); };

/** Все глобальные настройки. -> [{key, value, description}] */
export const APIAdminSettingsList = async (token) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/settings/`, adminAuthConfig(token)); return r.data?.items || []; }
    catch (e) { _err(e); throw e; }
};

/** Значение глобальной настройки по ключу. -> {key, value, description} | null (если ключа ещё нет) */
export const APIAdminGetSetting = async (token, key) => {
    try {
        const r = await axios.get(`${ADMIN_API_BASE}/settings/${key}/`, adminAuthConfig(token));
        return r.data?.setting || null;
    } catch (e) {
        if (e?.response?.status === 404) return null;
        _err(e); throw e;
    }
};

/** Обновить/создать значение настройки (нужна роль superadmin/finance). */
export const APIAdminUpdateSetting = async (token, key, value, description) => {
    try {
        const body = { value };
        if (description !== undefined) body.description = description;
        const r = await axios.put(`${ADMIN_API_BASE}/settings/${key}/update/`, body, adminAuthConfig(token));
        return r.data;
    } catch (e) { _err(e); throw e; }
};